var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-levitation-backtop"},[_c('a-back-top',[_c('div',{staticClass:"app-levitation-backtop-icon"},[_c('a-icon',{attrs:{"type":"vertical-align-top"}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }